export const DateFormater = (date, type = null)=>{
    let d = new Date(date)
    if(type === 'date'){
        return d.getDate().toString().padStart(2, "0") + '/' + (d.getMonth() + 1).toString().padStart(2, "0") + '/' + d.getFullYear()
    }else{
        return d.getHours().toString().padStart(2, "0") + ':' + d.getMinutes().toString().padStart(2, "0") + ' | ' +  d.getDate().toString().padStart(2, "0") + '/' + (d.getMonth() + 1).toString().padStart(2, "0") + '/' + d.getFullYear()
    }
}